import { Helmet } from "react-helmet";
import DefaultPage from "../components/defaultPage";
import Instructions from "../components/instructions";
import PageHeader from "../components/pageHeader";

const InstructionPage = () => {
  return (
    <>
      <Helmet>
        <title>Инструкции к часам Casio</title>
        <meta
          name="description"
          content="Найдите и откройте PDF-инструкцию к часам Casio по номеру модуля."
        />
      </Helmet>
      <PageHeader
        title="Инструкции к часам Casio"
        breadcrumbs={[
          {
            link: "/",
            text: "Инструкции",
          },
        ]}
      />
      <DefaultPage>
        <Instructions />
      </DefaultPage>
    </>
  );
};

export default InstructionPage;
